import {
    FETCH_SUBSCRIPTIONS,
    SAVE_SUBSCRIPTION,
    DELETE_SUBSCRIPTION,
} from '../types';
import api from '../api';

export const fetchSubscriptions = (restId) => {
    return {
        type: FETCH_SUBSCRIPTIONS,
        payload: api.restaurant.get(restId).orders.subscriptions.getAll()
    };
};

export const saveSubscription = (restId, sub) => {
    return {
        type: SAVE_SUBSCRIPTION,
        payload: api.restaurant.get(restId).orders.subscriptions.create(sub)
    };
};

export const deleteSubscription = (restId, subId) => {
    return {
        type: DELETE_SUBSCRIPTION,
        payload: api.restaurant.get(restId).orders.subscriptions.delete(subId),
        meta: { subId }
    };
};
